import { openDB } from "idb";

/**
 * MT19 — memoria telefonului, cât timp nu e semnal.
 *
 * O singură conexiune, deschisă la prima nevoie. Tiparul e cel deja probat pe
 * InOut, cu o singură deosebire: acolo unitatea era o sesiune de scanare, aici
 * e o FIȘĂ întreagă — cei cinci pași, cu tot ce a scris omul în hală.
 */
const NUME_BAZA = "mentenanta-teren";
const DEPOZIT = "fise-de-urcat";
/** Nomenclatoarele firmei, copiate în telefon când e semnal. Vezi `nomenclator()`. */
const NOMENCLATOR = "nomenclator";

let bazaPromise = null;
function baza() {
  if (!bazaPromise) {
    bazaPromise = openDB(NUME_BAZA, 2, {
      upgrade(db, veche) {
        // Cheia e identificatorul dat de telefon, nu cel de pe server: fișa
        // există în telefon cu mult înainte să existe pe server.
        if (veche < 1) db.createObjectStore(DEPOZIT, { keyPath: "localId" });
        if (veche < 2) db.createObjectStore(NOMENCLATOR);
      },
    });
  }
  return bazaPromise;
}

/**
 * Nomenclatoarele firmei, ținute în telefon.
 *
 * Pasul de operații își cerea lista la fiecare deschidere și o pierdea tăcut
 * fără semnal: un dropdown gol, fără niciun cuvânt despre de ce. Adică, exact
 * în hală, tehnicianul nu putea adăuga nicio operație — jumătate din rostul
 * modulului. Lista se copiază acum de fiecare dată când chiar vine de la
 * server, și se citește de aici când nu vine.
 *
 * Sunt DATE de citit, nu de urcat: nu intră niciodată în coada de fișe.
 */
export async function tineNomenclator(cheie, date) {
  try {
    const db = await baza();
    await db.put(NOMENCLATOR, { date, laLa: new Date().toISOString() }, cheie);
  } catch { /* fereastră privată: nu e o problemă de raportat aici */ }
}

export async function nomenclator(cheie) {
  try {
    const db = await baza();
    return (await db.get(NOMENCLATOR, cheie))?.date ?? null;
  } catch { return null; }
}

/**
 * Orice scriere ANUNȚĂ.
 *
 * Coada se schimbă din ecranul de teren, din sincronizare și din curățare —
 * adică din alte părți decât indicatorul care o arată. Fără semnalul ăsta,
 * pastila din bara de sus rămâne pe ce a citit la montare: omul salvează o fișă
 * în hală și nu vede nimic schimbându-se. O sondare periodică ar merge și ea,
 * dar ar întârzia exact acolo unde încrederea contează.
 */
const SEMNAL = "coada-teren-schimbata";
function anunta() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(SEMNAL));
}
export { SEMNAL };

export async function scrie(fisa) {
  const db = await baza();
  await db.put(DEPOZIT, { ...fisa, actualizataLa: new Date().toISOString() });
  anunta();
}

export async function toate() {
  const db = await baza();
  return db.getAll(DEPOZIT);
}

export async function citeste(localId) {
  const db = await baza();
  return db.get(DEPOZIT, localId);
}

export async function sterge(localId) {
  const db = await baza();
  await db.delete(DEPOZIT, localId);
  anunta();
}

/**
 * Există IndexedDB aici?
 *
 * Într-o fereastră privată, sau într-un browser cu datele de sit blocate,
 * deschiderea CRAPĂ. Un ecran de teren care se albește acolo e mai rău decât
 * unul care spune „nu pot ține datele local, lucrează cu semnal" — de-aia
 * întrebarea se pune o dată, la pornire, nu la prima salvare din hală.
 */
export async function potTineLocal() {
  try {
    await baza();
    return true;
  } catch {
    return false;
  }
}
